import { useState } from "react";
import { MessageCircle, Menu, X } from "lucide-react";
import { BrandLogo, WHATSAPP_URL } from "./shared";

const LINKS = [
  { label: "Serviços", href: "#servicos" },
  { label: "Como Funciona", href: "#protocolo" },
  { label: "Por que Nós", href: "#diferenciais" },
  { label: "Loja & Horários", href: "#unidade" },
  { label: "Avaliações", href: "#avaliacoes" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-[#252D33]/90 border-b border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-2 flex items-center justify-between">
        <a href="#top" aria-label="Pressi Celulares - início">
          <BrandLogo />
        </a>

        <nav className="hidden lg:flex items-center gap-7" aria-label="Navegação principal">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="font-mono-tech text-[11px] tracking-[0.18em] uppercase text-zinc-300 hover:text-[#ADCF5D] transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            data-testid="nav-whatsapp-cta"
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="hidden sm:flex items-center gap-2.5 bg-[#99BA4B] hover:bg-[#ADCF5D] text-[#1D2328] font-bold text-sm px-4 py-2.5 rounded-full transition-all duration-150 active:scale-95"
          >
            <span className="relative flex h-2 w-2">
              <span className="animate-ping-dot absolute inline-flex h-full w-full rounded-full bg-[#1D2328]" />
              <span className="relative inline-flex rounded-full h-2 w-2 bg-[#1D2328]" />
            </span>
            <MessageCircle size={16} strokeWidth={2.5} />
            WhatsApp
          </a>
          <button
            data-testid="nav-mobile-menu-btn"
            onClick={() => setOpen(!open)}
            className="lg:hidden text-zinc-200 p-2"
            aria-label="Abrir menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <nav
          className="lg:hidden border-t border-white/10 bg-[#252D33]/95 backdrop-blur-xl px-6 py-5 flex flex-col gap-4"
          data-testid="nav-mobile-menu"
        >
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="font-mono-tech text-xs tracking-[0.2em] uppercase text-zinc-200 hover:text-[#ADCF5D] transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-2 flex items-center justify-center gap-2 bg-[#99BA4B] text-[#1D2328] font-bold text-sm px-4 py-3 rounded-full"
          >
            <MessageCircle size={16} strokeWidth={2.5} />
            Chamar no WhatsApp
          </a>
        </nav>
      )}
    </header>
  );
}
